/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filtersaturation1Inputs */

const en_filtersaturation1 = /** @type {(inputs: Filtersaturation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saturation`)
};

const de_filtersaturation1 = /** @type {(inputs: Filtersaturation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sättigung`)
};

/**
* | output |
* | --- |
* | "Saturation" |
*
* @param {Filtersaturation1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const filtersaturation1 = /** @type {((inputs?: Filtersaturation1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filtersaturation1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filtersaturation1(inputs)
	return de_filtersaturation1(inputs)
});
export { filtersaturation1 as "filterSaturation" }